(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catagory-section-timeless"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Pre-load lazy images just before they slide into view (native lazy does not
     look inside horizontal scrollers, which caused blank cards). */
  function warm(root, slider) {
    var imgs = Array.prototype.slice.call(slider.querySelectorAll('img[loading="lazy"]'));
    if (!imgs.length) return;
    function load(img) { img.loading = 'eager'; }
    if (!('IntersectionObserver' in window)) { imgs.forEach(load); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
      });
    }, { root: slider, rootMargin: '0px 100% 0px 100%' });

    var gate = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      gate.disconnect();
      imgs.forEach(function (img) { io.observe(img); });
    }, { rootMargin: '600px 0px' });

    gate.observe(root);
  }

  function nav(root, slider) {
    var prev = root.querySelector('[data-tc-prev]');
    var next = root.querySelector('[data-tc-next]');
    var wrap = root.querySelector('.tc-desktop-nav');
    if (!prev || !next) return;

    var ticking = false;
    function update() {
      ticking = false;
      var max = slider.scrollWidth - slider.clientWidth;
      if (wrap) wrap.hidden = max <= 2;
      prev.disabled = slider.scrollLeft <= 2;
      next.disabled = slider.scrollLeft >= max - 2;
    }
    function queue() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    function step(dir) {
      slider.scrollBy({
        left: dir * Math.max(240, slider.clientWidth * 0.82),
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    slider.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(slider);
    update();
  }

  function init(root) {
    if (!root || root.dataset.tcReady === 'true') return;
    root.dataset.tcReady = 'true';
    var slider = root.querySelector('.tc-grid');
    if (!slider) return;
    warm(root, slider);
    nav(root, slider);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.tc-section'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('.tc-section'));
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target;
    var slider = card.closest && card.closest('.tc-grid');
    if (!slider) return;
    Array.prototype.forEach.call(card.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    if (slider.scrollWidth > slider.clientWidth) {
      slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft, behavior: 'auto' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const KEY = 'TimelessSmartCarousel';
  const make = (tag, cls, text) => { const n=document.createElement(tag); if(cls)n.className=cls; if(text!=null)n.textContent=text; return n; };

  if (!window[KEY]) window[KEY] = {
    roots:new Set(), activeCards:new Set(), cache:new Map(), revealObserver:null,
    modalTrigger:null, lockState:null, motionRaf:0, resizeRaf:0, bound:false,

    bindGlobal(){
      if(this.bound)return; this.bound=true;
      window.addEventListener('scroll',()=>this.scheduleMotion(),{passive:true});
      window.addEventListener('resize',()=>{ if(this.resizeRaf)return; this.resizeRaf=requestAnimationFrame(()=>{this.resizeRaf=0;this.roots.forEach(r=>this.updateArrows(r));this.scheduleMotion();}); },{passive:true});
      document.addEventListener('error',e=>{
        const img=e.target;
        if(!(img instanceof HTMLImageElement)||!img.matches('[data-tsc-root] .tsc__image--primary'))return;
        const fallback=img.dataset.tscFallback;

        if(fallback&&img.dataset.tscRetry!=='true'){
          img.dataset.tscRetry='true';
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.loading='eager';
          img.fetchPriority='auto';
          img.src=fallback;
          return;
        }

        img.classList.add('is-tsc-final-error');
      },true);

      document.addEventListener('keydown',e=>{if(e.key!=='Escape')return;const m=document.querySelector('[data-tsc-modal]:not([hidden])');if(m)this.closeModal(m.closest('[data-tsc-root]'));});
      document.addEventListener('shopify:section:load',e=>this.initAll(e.target));
      document.addEventListener('shopify:section:unload',e=>{const a=[];if(e.target?.matches?.('[data-tsc-root]'))a.push(e.target);e.target?.querySelectorAll?.('[data-tsc-root]').forEach(r=>a.push(r));a.forEach(r=>this.destroyRoot(r));});
    },

    observer(){
      if(!('IntersectionObserver' in window))return null;
      if(this.revealObserver)return this.revealObserver;
      this.revealObserver=new IntersectionObserver(entries=>{
        let changed=false;
        entries.forEach(entry=>{
          const n=entry.target;
          if(n.matches('[data-tsc-root]')){if(entry.isIntersecting){n.classList.add('is-inview');this.revealObserver.unobserve(n);}return;}
          if(!n.matches('[data-tsc-slide].tsc__card'))return;
          if(entry.isIntersecting){
            this.hydrateImage(n);
            if(!n.classList.contains('is-card-visible')){n.classList.add('is-card-visible');this.resolveSwatches(n);}
            this.activeCards.add(n); changed=true;
          }else if(this.activeCards.delete(n)){
            const img=n.querySelector('.tsc__image--primary');if(img){img.style.setProperty('--tsc-px','0px');img.style.setProperty('--tsc-py','0px');} changed=true;
          }
        });
        if(changed)this.scheduleMotion();
      },{root:null,rootMargin:'900px 420px',threshold:0});
      return this.revealObserver;
    },

    initRoot(root){
      if(!root||root.dataset.tscInit==='true')return; root.dataset.tscInit='true'; this.roots.add(root);
      const track=root.querySelector('[data-tsc-track]');if(!track)return;
      const io=this.observer();
      if(io){io.observe(root);root.querySelectorAll('[data-tsc-slide].tsc__card').forEach(c=>io.observe(c));}
      else{root.classList.add('is-inview');root.querySelectorAll('[data-tsc-slide].tsc__card').forEach(c=>{this.hydrateImage(c);c.classList.add('is-card-visible');this.resolveSwatches(c);});}
      let raf=0; const onScroll=()=>{if(raf)return;raf=requestAnimationFrame(()=>{raf=0;this.updateArrows(root);this.scheduleMotion();});};
      track.addEventListener('scroll',onScroll,{passive:true});root._tscTrackScroll=onScroll;
      root.addEventListener('click',e=>{
        if(e.target.closest('[data-tsc-prev]')){e.preventDefault();this.go(root,-1);return;}
        if(e.target.closest('[data-tsc-next]')){e.preventDefault();this.go(root,1);return;}
        const open=e.target.closest('[data-tsc-open]');if(open){e.preventDefault();this.openModal(root,open);return;}
        if(e.target.closest('[data-tsc-close]'))this.closeModal(root);
      });
      const warm=e=>{if(e.target.closest('.tsc__plus'))this.loadProductForm(root.dataset.productFormSrc);};
      root.addEventListener('pointerdown',warm,{passive:true});root.addEventListener('focusin',warm);
      this.updateArrows(root);this.resolveSwatches(root);
      const vh=window.innerHeight||document.documentElement.clientHeight;
      const vw=window.innerWidth||document.documentElement.clientWidth;
      root.querySelectorAll('[data-tsc-slide].tsc__card').forEach(card=>{
        const r=card.getBoundingClientRect();
        if(r.bottom>-120&&r.top<vh+900&&r.right>-120&&r.left<vw+420)this.hydrateImage(card);
      });
    },

    initAll(scope=document){this.bindGlobal();if(scope?.matches?.('[data-tsc-root]'))this.initRoot(scope);scope?.querySelectorAll?.('[data-tsc-root]').forEach(r=>this.initRoot(r));},
    destroyRoot(root){if(!root)return;this.roots.delete(root);this.revealObserver?.unobserve(root);root.querySelectorAll('[data-tsc-slide].tsc__card').forEach(c=>{this.revealObserver?.unobserve(c);this.activeCards.delete(c);});const t=root.querySelector('[data-tsc-track]');if(t&&root._tscTrackScroll)t.removeEventListener('scroll',root._tscTrackScroll);delete root.dataset.tscInit;if(this.modalTrigger&&root.contains(this.modalTrigger)){this.modalTrigger=null;this.unlock();}},

    hydrateImage(card){
      const img=card?.querySelector?.('[data-tsc-deferred-image]');
      if(!img||img.dataset.tscHydrated==='true')return;
      img.dataset.tscHydrated='true';

      const sizes=img.dataset.tscSizes;
      const srcset=img.dataset.tscSrcset;
      const realSrc=img.dataset.tscSrc;

      img.loading='eager';
      img.fetchPriority='auto';
      if(sizes)img.sizes=sizes;
      if(srcset)img.srcset=srcset;
      if(realSrc)img.src=realSrc;

      img.removeAttribute('data-tsc-deferred-image');
      img.removeAttribute('data-tsc-sizes');
      img.removeAttribute('data-tsc-srcset');
      img.removeAttribute('data-tsc-src');
    },

    resolveSwatches(scope){scope.querySelectorAll?.('[data-tsc-color-name]').forEach(s=>{if(s.dataset.tscColorResolved==='true')return;s.dataset.tscColorResolved='true';const c=(s.dataset.tscColorName||'').replace(/\s+/g,'').toLowerCase();if(c&&CSS.supports('color',c))s.style.setProperty('--tsc-swatch-bg',c);});},

    scheduleMotion(){
      if(this.motionRaf)return;this.motionRaf=requestAnimationFrame(()=>{this.motionRaf=0;if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
        const w=innerWidth||document.documentElement.clientWidth,h=innerHeight||document.documentElement.clientHeight;
        this.activeCards.forEach(card=>{if(!card.isConnected){this.activeCards.delete(card);return;}const root=card.closest('[data-tsc-root]'),img=card.querySelector('.tsc__image--primary');if(!root||!img)return;const sx=Number(root.dataset.parallaxX||0),sy=Number(root.dataset.parallaxY||0);if(!sx&&!sy)return;const r=card.getBoundingClientRect();if(r.right<-100||r.left>w+100||r.bottom<-100||r.top>h+100)return;const nx=Math.max(-1,Math.min(1,(r.left+r.width/2-w/2)/Math.max(w/2,1))),ny=Math.max(-1,Math.min(1,(r.top+r.height/2-h/2)/Math.max(h/2,1)));img.style.setProperty('--tsc-px',`${(-nx*sx).toFixed(2)}px`);img.style.setProperty('--tsc-py',`${(-ny*sy).toFixed(2)}px`);});
      });
    },

    updateArrows(root){const t=root?.querySelector('[data-tsc-track]');if(!t)return;const p=root.querySelector('[data-tsc-prev]'),n=root.querySelector('[data-tsc-next]'),max=Math.max(0,t.scrollWidth-t.clientWidth),left=t.scrollLeft;if(p)p.disabled=max<=2||left<=2;if(n)n.disabled=max<=2||left>=max-2;},
    go(root,dir){const t=root?.querySelector('[data-tsc-track]');if(!t)return;const slides=[...t.querySelectorAll('[data-tsc-slide]')];if(!slides.length)return;const max=Math.max(0,t.scrollWidth-t.clientWidth),left=t.scrollLeft;let cur=0,dist=Infinity;slides.forEach((s,i)=>{const x=Math.max(0,Math.min(max,s.offsetLeft-t.offsetLeft)),d=Math.abs(x-left);if(d<dist){dist=d;cur=i;}});const trg=slides[Math.max(0,Math.min(slides.length-1,cur+dir))],x=Math.max(0,Math.min(max,trg.offsetLeft-t.offsetLeft));t.scrollTo({left:x,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});},

    loadProductForm(src){if(!src||customElements.get('product-form')||document.querySelector('script[data-tsc-product-form],script[src*="product-form"]'))return;const s=document.createElement('script');s.src=src;s.defer=true;s.dataset.tscProductForm='true';document.head.appendChild(s);},
    fetchProduct(root,handle){if(!handle)return Promise.reject(new Error('Missing handle'));const url=`${root.dataset.productsUrl}${encodeURIComponent(handle)}.js`;let p=this.cache.get(url);if(!p){p=fetch(url,{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error(`HTTP ${r.status}`);return r.json();});p.catch(()=>this.cache.delete(url));this.cache.set(url,p);}return p;},

    lock(){if(this.lockState)return;this.lockState={h:document.documentElement.style.overflow,b:document.body.style.overflow,t:document.body.style.touchAction};document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';document.body.style.touchAction='none';},
    unlock(){if(!this.lockState)return;document.documentElement.style.overflow=this.lockState.h;document.body.style.overflow=this.lockState.b;document.body.style.touchAction=this.lockState.t;this.lockState=null;},
    closeModal(root){const m=root?.querySelector('[data-tsc-modal]'),slot=m?.querySelector('[data-tsc-slot]');if(!m)return;m.hidden=true;root.classList.remove('tsc--modal-open');slot?.replaceChildren();this.unlock();if(this.modalTrigger&&document.contains(this.modalTrigger))this.modalTrigger.focus({preventScroll:true});this.modalTrigger=null;},

    openModal(root,trigger){
      const m=root.querySelector('[data-tsc-modal]'),slot=m?.querySelector('[data-tsc-slot]');if(!m||!slot)return;this.modalTrigger=trigger;root.classList.add('tsc--modal-open');this.loadProductForm(root.dataset.productFormSrc);this.lock();const d=trigger.dataset,c=make('div','tsc__modal-content');c.setAttribute('data-tsc-modal-content','');const head=make('div','tsc__modal-head');if(d.image){const wrap=make('div','tsc__modal-image'),img=document.createElement('img');img.src=d.image;img.alt=d.alt||d.title||'';img.loading='lazy';img.decoding='async';img.width=240;wrap.appendChild(img);head.appendChild(wrap);}const info=make('div');info.append(make('p','tsc__modal-kicker',root.dataset.modalKicker||''),make('h3',null,d.title||''),make('p','tsc__modal-price',d.price||''));head.appendChild(info);const opts=make('div','tsc__options'),status=make('p','tsc__modal-status','Loading options...');opts.appendChild(status);c.append(head,opts);slot.replaceChildren(c);m.hidden=false;this.fetchProduct(root,d.handle).then(product=>{if(this.modalTrigger!==trigger)return;this.renderOptions(root,c,opts,product,d.variant);m.querySelector('[data-tsc-close]')?.focus({preventScroll:true});}).catch(()=>{if(this.modalTrigger!==trigger)return;status.textContent='Could not load options.';if(d.url){const a=make('a','tsc__view','View product');a.href=d.url;opts.appendChild(a);}});
    },

    renderOptions(root,content,options,product,preferredId){
      const variants=product.variants||[],names=(product.options||[]).map(o=>typeof o==='string'?o:o.name),val=(v,i)=>v.options&&v.options[i]!=null?v.options[i]:v[`option${i+1}`],start=variants.find(v=>String(v.id)===String(preferredId))||variants.find(v=>v.available)||variants[0],selected=names.map((_,i)=>start?val(start,i):null);options.replaceChildren();const input=document.createElement('input');input.type='hidden';input.name='id';input.className='product-variant-id';const add=make('button','tsc__modal-add'),txt=make('span');add.type='submit';add.name='add';add.appendChild(txt);const update=()=>{const v=variants.find(x=>names.every((_,i)=>String(val(x,i))===String(selected[i]))),ok=Boolean(v&&v.available);if(v)input.value=v.id;input.disabled=!ok;add.disabled=!ok;txt.textContent=ok?root.dataset.addLabel:'SOLD OUT';};names.forEach((name,i)=>{const group=make('fieldset','tsc__option-group');group.appendChild(make('legend',null,name));const values=make('div','tsc__option-values');[...new Set(variants.map(v=>val(v,i)))].forEach(value=>{const chip=make('button',`tsc__option${value===selected[i]?' is-selected':''}`,value);chip.type='button';chip.setAttribute('aria-pressed',value===selected[i]?'true':'false');chip.addEventListener('click',()=>{selected[i]=value;values.querySelectorAll('.tsc__option').forEach(x=>{const on=x===chip;x.classList.toggle('is-selected',on);x.setAttribute('aria-pressed',on?'true':'false');});update();});values.appendChild(chip);});group.appendChild(values);options.appendChild(group);});const pf=document.createElement('product-form');pf.className='tsc__modal-form';const err=make('div','product-form__error-message-wrapper');err.setAttribute('role','alert');err.hidden=true;err.appendChild(make('span','product-form__error-message'));const form=document.createElement('form');form.method='post';form.action=root.dataset.cartUrl;form.enctype='multipart/form-data';form.setAttribute('novalidate','novalidate');form.dataset.type='add-to-cart';const sp=make('span','loading__spinner hidden'),tpl=root.querySelector('[data-tsc-spinner]');if(tpl)sp.appendChild(tpl.content.cloneNode(true));add.appendChild(sp);form.append(input,add);pf.append(err,form);content.appendChild(pf);update();
    }
  };

  const boot=()=>window[KEY].initAll(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
(() => {
  const KEY = 'TimelessFlashSaleController';

  if (window[KEY]) {
    window[KEY].initAll(document);
    return;
  }

  const controller = {
    roots: new Set(),
    observer: null,
    tickId: 0,
    sectionEventsBound: false,

    pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    },

    resolveDeadline(root) {
      const year = Math.max(2026, Number(root.dataset.endYear || 2026));
      const month = Math.min(12, Math.max(1, Number(root.dataset.endMonth || 1)));
      const requestedDay = Math.min(31, Math.max(1, Number(root.dataset.endDay || 1)));
      const hour12 = Math.min(12, Math.max(1, Number(root.dataset.endHour || 12)));
      const minute = Math.min(59, Math.max(0, Number(root.dataset.endMinute || 0)));
      const ampm = String(root.dataset.endAmpm || 'PM').toUpperCase();
      const timezone = String(root.dataset.endTimezone || '+05:00');

      const maxDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
      const day = Math.min(requestedDay, maxDay);

      let hour24 = hour12 % 12;
      if (ampm === 'PM') hour24 += 12;

      const iso =
        `${year}-${this.pad(month)}-${this.pad(day)}` +
        `T${this.pad(hour24)}:${this.pad(minute)}:00${timezone}`;

      const parsed = Date.parse(iso);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    resolveClockOffset(root) {
      const serverSeconds = Number(root.dataset.serverNow || 0);
      const serverMs = serverSeconds > 0 ? serverSeconds * 1000 : 0;
      return serverMs > 0 ? serverMs - Date.now() : 0;
    },

    now(root) {
      return Date.now() + Number(root._tfsClockOffset || 0);
    },

    render(root) {
      const nodes = root._tfsNodes;
      if (!nodes?.timer) {
        root._tfsActive = false;
        return;
      }

      const remaining = Math.max(0, root._tfsDeadline - this.now(root));

      if (remaining <= 0) {
        if (root.dataset.hideExpired === 'true') {
          root.hidden = true;
          root._tfsActive = false;
          return;
        }

        nodes.timer.hidden = true;

        if (nodes.expired) {
          nodes.expired.hidden = false;
          nodes.expired.textContent = root.dataset.expiredMessage || 'SALE ENDED';
        }

        root._tfsActive = false;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const next = [days, hours, minutes, seconds];
      const previous = root._tfsLast || [];

      if (nodes.days && next[0] !== previous[0]) nodes.days.textContent = this.pad(next[0]);
      if (nodes.hours && next[1] !== previous[1]) nodes.hours.textContent = this.pad(next[1]);
      if (nodes.minutes && next[2] !== previous[2]) nodes.minutes.textContent = this.pad(next[2]);
      if (nodes.seconds && next[3] !== previous[3]) nodes.seconds.textContent = this.pad(next[3]);

      root._tfsLast = next;
    },

    tick() {
      this.tickId = 0;
      let hasActive = false;

      this.roots.forEach((root) => {
        if (!root.isConnected) {
          this.roots.delete(root);
          return;
        }

        if (!root._tfsActive) return;

        this.render(root);
        if (root._tfsActive) hasActive = true;
      });

      if (hasActive) {
        const firstActive = [...this.roots].find((root) => root._tfsActive);
        const clockNow = firstActive ? this.now(firstActive) : Date.now();
        const delay = Math.max(250, 1010 - (clockNow % 1000));
        this.tickId = window.setTimeout(() => this.tick(), delay);
      }
    },

    ensureTicking() {
      if (this.tickId) return;
      this.tick();
    },

    ensureObserver() {
      if (this.observer || !('IntersectionObserver' in window)) return this.observer;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const root = entry.target;
          root._tfsActive = entry.isIntersecting;

          if (entry.isIntersecting) {
            this.render(root);
            this.ensureTicking();
          }
        });
      }, {
        root: null,
        rootMargin: '80px 0px',
        threshold: 0
      });

      return this.observer;
    },

    initRoot(root) {
      if (!root || root.dataset.tfsReady === 'true') return;

      root.dataset.tfsReady = 'true';

      const timer = root.querySelector('[data-tfs-timer]');
      if (!timer) return;

      root._tfsNodes = {
        timer,
        days: root.querySelector('[data-tfs-days]'),
        hours: root.querySelector('[data-tfs-hours]'),
        minutes: root.querySelector('[data-tfs-minutes]'),
        seconds: root.querySelector('[data-tfs-seconds]'),
        expired: root.querySelector('[data-tfs-expired]')
      };

      root._tfsClockOffset = this.resolveClockOffset(root);
      root._tfsDeadline = this.resolveDeadline(root);
      root._tfsActive = true;

      this.roots.add(root);
      this.render(root);

      const observer = this.ensureObserver();

      if (observer) {
        root._tfsActive = false;
        observer.observe(root);
      } else {
        this.ensureTicking();
      }
    },

    initAll(scope = document) {
      if (scope?.matches?.('[data-tfs-root]')) {
        this.initRoot(scope);
      }

      scope?.querySelectorAll?.('[data-tfs-root]').forEach((root) => {
        this.initRoot(root);
      });

      if (!this.sectionEventsBound) {
        this.sectionEventsBound = true;

        document.addEventListener('shopify:section:load', (event) => {
          this.initAll(event.target);
        });

        document.addEventListener('shopify:section:unload', (event) => {
          const roots = event.target?.matches?.('[data-tfs-root]')
            ? [event.target]
            : [...(event.target?.querySelectorAll?.('[data-tfs-root]') || [])];

          roots.forEach((root) => {
            this.observer?.unobserve(root);
            this.roots.delete(root);
            delete root._tfsNodes;
            delete root._tfsLast;
            delete root._tfsDeadline;
            delete root._tfsClockOffset;
            delete root._tfsActive;
          });
        });
      }
    }
  };

  window[KEY] = controller;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => controller.initAll(document), { once: true });
  } else {
    controller.initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timelss-baner"] && !Shopify.designMode) return;
  try {
    

(() => {

  if (window.__TMXFI_ENGINE_V4__) return;

  window.__TMXFI_ENGINE_V4__ = true;



  const states = new Map();

  const activeMotionStates = new Set();

  const reduceMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');

  const mobileMq = window.matchMedia('(max-width: 749px)');

  let frame = 0;



  const schedule = () => {

    if (frame || activeMotionStates.size === 0) return;

    frame = requestAnimationFrame(flush);

  };



  const updateState = (state) => {

    const rect = state.root.getBoundingClientRect();

    const viewport = window.innerHeight || document.documentElement.clientHeight;

    const center = rect.top + rect.height / 2;

    const normalized = Math.max(-1, Math.min(1, (center - viewport / 2) / (viewport / 2)));

    const mobileFactor = mobileMq.matches ? .65 : 1;



    if (state.driftEnabled) {

      const textY = normalized * state.driftStrength * -.16 * mobileFactor;

      state.root.style.setProperty('--tmxfi-copy-drift', `${textY.toFixed(2)}px`);

    }



    if (state.imageParallaxEnabled) {

      const progress = 1 - Math.abs(normalized);

      const maxScale = 1 + (state.zoomStrength / 100);

      const scale = 1 + ((maxScale - 1) * progress);

      const shift = -normalized * state.imageShiftStrength * mobileFactor;

      state.root.style.setProperty('--tmxfi-image-scale', scale.toFixed(4));

      state.root.style.setProperty('--tmxfi-image-shift', `${shift.toFixed(2)}px`);

    }

  };



  function flush() {

    frame = 0;

    activeMotionStates.forEach(updateState);

  }



  const markImage = (img) => {
    const media = img.closest('.tmxfi-media');
    if (!media) return;

    const ready = () => {
      media.classList.remove('tmxfi-image-error');
      media.classList.add('tmxfi-image-ready');
    };

    const fail = () => {
      media.classList.remove('tmxfi-image-ready');
      media.classList.add('tmxfi-image-error');

      const label = media.querySelector('.tmxfi-loading-label');
      if (label) label.textContent = 'IMAGE UNAVAILABLE';
    };

    if (img.complete) {
      if (img.naturalWidth > 0) ready();
      else fail();
      return;
    }

    img.addEventListener('load', ready, { once: true });
    img.addEventListener('error', fail, { once: true });
  };

  const primeImages = (state) => {
    if (!state || state.primed) return;
    state.primed = true;

    const images = [...state.root.querySelectorAll('[data-tmxfi-image]')];

    images.forEach((img, index) => {
      const promote = () => {
        if (img.complete && img.naturalWidth > 0) return;

        img.loading = 'eager';

        if (
          index === 0 &&
          state.root.getBoundingClientRect().top < (window.innerHeight || document.documentElement.clientHeight) + 240
        ) {
          img.fetchPriority = 'high';
        }
      };

      if (index === 0) promote();
      else window.setTimeout(promote, index * 55);
    });
  };

  const observer = 'IntersectionObserver' in window

    ? new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          const state = states.get(entry.target);

          if (!state) return;



          state.active = entry.isIntersecting;

          state.root.classList.toggle('tmxfi-near', state.active);

          state.root.classList.toggle('tmxfi-parallax-active', state.active && state.imageParallaxEnabled);



          
          if (state.active) primeImages(state);

          if (state.active && !state.entered) {

            state.entered = true;

            requestAnimationFrame(() => state.root.classList.add('tmxfi-entered'));

          }



          if (state.active && state.needsMotion) {

            activeMotionStates.add(state);

            schedule();

          } else {

            activeMotionStates.delete(state);

          }

        });

      }, {

        root: null,

        rootMargin: '620px 0px 620px',
        threshold: 0

      })

    : null;



  const register = (root) => {

    if (!root || states.has(root)) return;



    const reduceMotion = reduceMotionMq.matches;

    const state = {

      root,

      active: false,

      entered: false,
      primed: false,

      revealEnabled: root.dataset.tmxfiReveal === 'true' && !reduceMotion,

      driftEnabled: root.dataset.tmxfiDrift === 'true' && !reduceMotion,

      driftStrength: Number(root.dataset.tmxfiDriftStrength || 0),

      imageParallaxEnabled: root.dataset.tmxfiImageParallax === 'true' && !reduceMotion,

      zoomStrength: Number(root.dataset.tmxfiZoomStrength || 0),

      imageShiftStrength: Number(root.dataset.tmxfiShiftStrength || 0)

    };

    state.needsMotion = state.driftEnabled || state.imageParallaxEnabled;



    states.set(root, state);

    root.classList.add('tmxfi-js');



    if (state.revealEnabled) {

      root.classList.add('tmxfi-motion');

    } else {

      state.entered = true;

      root.classList.add('tmxfi-entered');

    }



    root.querySelectorAll('[data-tmxfi-image]').forEach(markImage);



    
    const initialRect = root.getBoundingClientRect();
    const initialViewport = window.innerHeight || document.documentElement.clientHeight;

    if (initialRect.top < initialViewport + 620 && initialRect.bottom > -220) {
      state.active = true;
      root.classList.add('tmxfi-near');
      primeImages(state);
    }

    if (observer) {

      observer.observe(root);

    } else {

      state.active = true;

      state.entered = true;

      root.classList.add('tmxfi-near', 'tmxfi-entered');

            primeImages(state);
      root.classList.toggle('tmxfi-parallax-active', state.imageParallaxEnabled);

      if (state.needsMotion) {

        activeMotionStates.add(state);

        schedule();

      }

    }

  };



  const unregister = (root) => {

    if (!root) return;

    const state = states.get(root);

    if (!state) return;

    if (observer) observer.unobserve(root);

    activeMotionStates.delete(state);

    states.delete(root);

  };



  const scan = (scope) => {

    if (!scope) return;

    if (scope.matches?.('[data-tmxfi-root]')) register(scope);

    scope.querySelectorAll?.('[data-tmxfi-root]').forEach(register);

  };



  scan(document);

  window.addEventListener('scroll', schedule, { passive: true });

  window.addEventListener('resize', schedule, { passive: true });



  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  document.addEventListener('shopify:section:unload', (event) => {

    if (event.target.matches?.('[data-tmxfi-root]')) unregister(event.target);

    event.target.querySelectorAll?.('[data-tmxfi-root]').forEach(unregister);

  });

})();


  } catch(e) { console.error(e); }
})();
})();
